import React from 'react';
import { connect } from 'react-redux';

import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

import { ProviderTypeScrollPosition, RootState } from '../types/providerSearch';
import { setProviderType, setScrollPosition, setProviderSpecialty } from '../actions';
import { colors } from '../../style/colors';

const TaxonomyTextContainer = styled('div')({
  display: 'flex',
  margin: '0.3rem 0',
});

const StyledButton = styled(Button)({
  padding: 0,
  textDecoration: `underline #F97140`,
  textTransform: 'none',
  '&:hover': {
    backgroundColor: 'transparent',
    color: colors.orangeDark,
    textDecoration: `underline #F97140`,
  },
  '&.Mui-disabled': {
    textDecoration: 'none',
  },
});

const CategoryButton = styled(StyledButton)({
  flex: '0 1 auto',
  whiteSpace: 'nowrap',
  minWidth: 0,
});

const TitleButton = styled(StyledButton)({
  flex: '1 0 auto',
  maxWidth: 'max-content',
});

const StyledText = styled(Typography)({
  color: colors.orange,
  fontSize: '.85rem',
  textTransform: 'none',
});

const CategoryText = styled(StyledText)({
  overflow: 'hidden',
  textOverflow: 'ellipsis',
});

type ParentProps = {
  category: string;
  title: string;
};

const mapStateToProps = ({ providerSearch }: RootState): StateProps => ({
  scrollPosition: providerSearch.scrollPosition,
  selectedProviderType: providerSearch.selectedProviderType,
});

type StateProps = {
  scrollPosition: ProviderTypeScrollPosition;
  selectedProviderType: string;
};

const mapDispatchToProps = {
  setProviderType,
  setProviderSpecialty,
  setScrollPosition,
};

type Props = ParentProps & StateProps & typeof mapDispatchToProps;

export function CategoryAndTitle({
  category,
  title,
  setProviderType,
  setProviderSpecialty,
  setScrollPosition,
  selectedProviderType,
}: Props): JSX.Element {
  if (!category || !title) return <div />;

  const handleClick =
    (isTitle = false) =>
    (): void => {
      if (isTitle === false) setProviderType(category);
      else {
        setProviderType(category);
        setProviderSpecialty(title);
      }
      setScrollPosition({ category, isTitle });
    };

  return (
    <TaxonomyTextContainer>
      <CategoryButton onClick={handleClick()} disabled={category === selectedProviderType}>
        <CategoryText>{category}</CategoryText>
      </CategoryButton>
      <StyledText>&nbsp;/&nbsp;</StyledText>
      <TitleButton onClick={handleClick(true)} disabled={title === selectedProviderType}>
        <StyledText>{title}</StyledText>
      </TitleButton>
    </TaxonomyTextContainer>
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(CategoryAndTitle);
